<template>
  <div class="LocatieInformatie__Content">
    <!--      <div class="LocatieInformatie__StreetViewImage">
            <img src="@/assets/image/style-light.png">
            <img src="@/assets/image/style-satellite.png">
          </div>-->
    <template v-if="address">
      <p>
        <strong>Adres</strong><br/>
        {{ address.simple_address }} <br/>
        {{ address.postalcode }} {{ address.city }}
      </p>

      <p v-if="coordinates">
        <strong>Coordinaten</strong><br/>
        {{ coordinates['lat'] }} <br/>
        {{ coordinates['lng'] }}
      </p>
    </template>
    <p v-else>
      <strong>Adres</strong><br/>
      Onbekend
    </p>

    <p v-if="status">
      <strong>Status</strong><br/>
      {{ statusLabel }}
    </p>

    <p v-if="currentCpo">
      <strong>Charge Point Operator</strong><br/>
      {{ currentCpo.name }}
    </p>

    <p v-if="prio && prio.order">
      <strong>Prioriteit</strong><br/>
      {{ prio.order }}
      {{ prio.fase === 1 ? '(Fase 1)' : '' }}
      {{ isBraLiProvincieCode && prio.fase === 2 ? '(Fase 2)' : '' }}
    </p>

    <p v-if="plannerName">
      <strong>Gebruiker</strong><br/>
      {{ plannerName }}
    </p>

    <p v-if="remark">
      <strong>Toelichting</strong><br/>
      <template>
        {{ remark }}
      </template>
    </p>
    <!--        <p>
              <strong>Type</strong><br />
              {{ properties.type }}
            </p>-->
    <!--        <p>
              <strong>Toegang</strong><br />
              Publiek
            </p>-->
    <p>
      <strong>Locatiebeheer</strong>
    </p>
    <p>
      <strong>Beheerder</strong><br />
      {{ beheerder ? beheerder.name : 'Geen' }}
    </p>
    <div class="the-validators">
      <p class="mb-0">
        <strong>Validatoren</strong>
      </p>
      <ul v-if="hasValidators">
        <li
          v-for="validator in validators"
          :key="validator.user_id"
        >
          {{ validator.name }}
        </li>
      </ul>
      <span v-else>
        Geen
      </span>
    </div>
  </div>
</template>

<script>
import chargingpointDataMixin from "@/mixins/chargingpoint/chargingpointDataMixin";

export default {
  props: {
    chargingpoint: {
      type: Object,
      required: true
    }
  },
  mixins: [chargingpointDataMixin],
}
</script>